export default "__VITE_ASSET__DmCJ8azj__"